// Helpery do pól z ceną:
// - zamienia , na .
// - zostawia tylko jedną kropkę
// - maksymalnie dwie cyfry po kropce
// - usuwa wszystkie znaki inne niż cyfry i kropka

export function sanitizePrice (value) {
  if (value === null || value === undefined) {
    return ''
  }

  let result = String(value).replace(',', '.').replace(/[^0-9.]/g, '')

  const firstDot = result.indexOf('.')
  if (firstDot !== -1) {
    // zostaw pierwszą kropkę, usuń kolejne
    result = result.slice(0, firstDot + 1) + result.slice(firstDot + 1).replace(/\./g, '')
    // maksymalnie dwie cyfry po kropce
    result = result.slice(0, firstDot + 3)
  }

  return result
}

export function toPrice (value) {
  const sanitized = sanitizePrice(value)
  if (sanitized === '' || sanitized === '.') {
    return null
  }

  const num = parseFloat(sanitized)
  return isNaN(num) ? null : num
}
